import { request2 } from "../request2";

export const getAllCoupon = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/coupon/all',
		params
	})
}
export const addCoupon = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/coupon/add',
		params
	})
}

export const editCouponStatus = (id, status) => {
	return request2({
		method: 'post',
		url: `/dashboard/coupon/status/${id}`,
		params:{status}
	})
}
export const getAllCouponHistory = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/coupon/history',
		params
	})
}